__turbopack_context__.v({
  "form": "Search-module__XclSvG__form",
  "input": "Search-module__XclSvG__input",
  "inputContainer": "Search-module__XclSvG__inputContainer",
  "open": "Search-module__XclSvG__open",
  "resetButton": "Search-module__XclSvG__resetButton",
  "searchButton": "Search-module__XclSvG__searchButton",
});
